import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useMap } from "context/mapContext";
import { handleLoading, useLoading } from "context/LoadingContext";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import handleZoom from "utils/handleZoom";
// import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import getEsriSpatialData from "context/contextFunctions/getEsriSpatialData";
// import clearDuplicatedItemFromArrOfObject from "utils/clearDuplicatedItemFromArrOfObject";
import HomeVM from "@arcgis/core/widgets/Home/HomeViewModel";

function MapSelectors() {
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm();
  const [, loadingDispatch] = useLoading();
  const [map, dispatchMap] = useMap();
  const {
    govsList,
    munsLayer,
    munsList,
    localitiesLayer,
    localitiesList,
    polesSelectionComponentMode,
    polesLayer,
    view,
    graphicsLayer,
    // polesList,
    webMap,
    bordersGraphicLayer,
  } = map;

  const [home, setHome] = useState(null);

  useEffect(() => {
    const tempHome = new HomeVM({
      view,
      viewpoint: webMap?.initialViewProperties?.viewpoint,
    });
    setHome(tempHome);
  }, [webMap]);

  const allowEdit = polesSelectionComponentMode === "newJobZone";

  const [selectedMun, setSelectedMun] = useState("");
  const [selectedLocality, setSelectedLocality] = useState("");

  const [refactoredmunsList, setRefactoredmunsList] = useState([
    { label: "All", value: "" },
  ]);
  const [refactoredLocalitiesList, setRefactoredLocalitiesList] = useState([
    { label: "All", value: "" },
  ]);

  const hasChosenGov = useWatch({ control, name: "gov" });

  const onSubmit = async () => {
    handleLoading(loadingDispatch, true);

    try {
      let queryGeometry;
      if (selectedLocality) {
        queryGeometry = localitiesList?.find(
          (locality) => locality.Locality_E === selectedLocality
        ).geometry;
      } else {
        queryGeometry = munsList?.find(
          (mun) => mun.Municipality_E_1 === selectedMun
        ).geometry;
      }
      const query = "Status IS NULL";

      const token = localStorage.getItem("token");
      if (polesLayer && view && token) {
        const { res: polesRes } = await getEsriSpatialData({
          geometry: queryGeometry,
          returnGeometry: true,
          outSpatialReference: view?.spatialReference,
          view,
          outFields: "*",
          featureLayer: polesLayer,
          query,
          neededDomains: ["Pole_Type"],
        });

        // const newMergedPolesList = clearDuplicatedItemFromArrOfObject(
        //   [...polesList, ...polesRes],
        //   "OBJECTID"
        // );

        dispatchMap({
          type: "INIT",
          payload: {
            polesList: polesRes,
            selectionGeometry: queryGeometry,
          },
        });

        handleZoom(polesRes, view, graphicsLayer);
      }
    } catch (error) {
      console.log(error);
    }
    handleLoading(loadingDispatch, false);
  };

  const handleChangeGov = async (e) => {
    handleLoading(loadingDispatch, true);
    try {
      const token = localStorage.getItem("token");
      if (view && token && munsLayer) {
        const govName = e.target.value;
        const { res: munsListRes } = await getEsriDataFromLayer({
          featureLayer: munsLayer,
          query: `Governorate_English_Name  LIKE '%${govName}%'`,
          returnGeometry: true,
          view,
        });

        // const { res: localitiesListRes } = await getEsriDataFromLayer({
        //   featureLayer: localitiesLayer,
        //   query: `Governorate_E = '${govName}'`,
        //   returnGeometry: true,
        //   view,
        // });

        // view.goTo(munsListRes);
        handleZoom(munsListRes, view, bordersGraphicLayer);

        dispatchMap({
          type: "INIT",
          payload: {
            munsList: munsListRes,
            // localitiesList: localitiesListRes,
          },
        });
        setSelectedMun("");
        setSelectedLocality("");
      }
    } catch (error) {
      console.log(error);
    }
    handleLoading(loadingDispatch, false);
  };

  const handleChangeMun = async (e) => {
    const wantedMun = e.target.value;

    const { res: localitiesListRes } = await getEsriDataFromLayer({
      featureLayer: localitiesLayer,
      query: `Municipality_E ='${wantedMun}'`,
      returnGeometry: true,
      view,
    });

    const tempSelectedMun = munsList?.find(
      (mun) => mun.Municipality_E_1 === wantedMun
    );
    // view.goTo(selectedMunsObjs);
    setSelectedMun(wantedMun);
    setSelectedLocality("");
    handleZoom([tempSelectedMun], view, bordersGraphicLayer);

    dispatchMap({
      type: "INIT",
      payload: {
        munQuery: wantedMun ? `Municipality ='${wantedMun}'` : "1=1",
        localitiesList: localitiesListRes,
      },
    });
  };

  const handleChangeLocality = async (e) => {
    const wantedLocality = e.target.value;
    setSelectedLocality(wantedLocality);

    const tempSelectedLoc = localitiesList?.find(
      (loc) => loc.Locality_E === wantedLocality
    );

    handleZoom([tempSelectedLoc], view, bordersGraphicLayer);
  };

  const handleReset = () => {
    reset();
    setSelectedMun("");
    setSelectedLocality("");
    bordersGraphicLayer.removeAll();
    // graphicsLayer.removeAll();
    dispatchMap({
      type: "INIT",
      payload: {
        munQuery: null,
      },
    });
    home.go();
  };

  const handleResetAfterSubmit = () => {
    reset();
    setSelectedMun("");
    setSelectedLocality("");
    dispatchMap({
      type: "INIT",
      payload: {
        munQuery: null,
      },
    });
    graphicsLayer.removeAll();
    home?.go();
  };

  useEffect(() => {
    const tempMunsList = munsList?.map((mun) => ({
      label: mun.Municipality_A_1,
      value: mun.Municipality_E_1,
    }));
    setRefactoredmunsList(tempMunsList);
  }, [munsList]);

  useEffect(() => {
    const tempLocalitiesList = localitiesList?.map((loc) => ({
      label: loc.Locality_A,
      value: loc.Locality_E,
    }));
    setRefactoredLocalitiesList(tempLocalitiesList);
  }, [localitiesList]);

  useEffect(() => {
    dispatchMap({
      type: "INIT",
      payload: {
        resetFunction: handleResetAfterSubmit,
      },
    });
  }, [home]);

  return (
    <form
      className="map-selectors"
      id="mapSelectors"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="select" style={{ minWidth: "12rem", maxWidth: "12rem" }}>
        <Form.Group>
          <Form.Label>Governorate</Form.Label>
          <Form.Select
            defaultValue=""
            {...register("gov", {
              required: "Please Select a Governorate",
              onChange: (e) => handleChangeGov(e),
            })}
            disabled={!allowEdit}
          >
            <option value="">- Select -</option>
            {govsList?.length &&
              govsList?.map((item) => (
                <option
                  key={item.Governorate_English_Name}
                  value={item.Governorate_English_Name}
                >
                  {item.Governorate_Arabic_Name}
                </option>
              ))}
          </Form.Select>
          {errors.gov && (
            <Form.Text className="text-danger">{errors.gov.message}</Form.Text>
          )}
        </Form.Group>
      </div>
      <div className="select" style={{ minWidth: "12rem", maxWidth: "12rem" }}>
        <Form.Label>Municipality</Form.Label>
        <Form.Select
          defaultValue=""
          disabled={!hasChosenGov}
          onChange={handleChangeMun}
          value={selectedMun}
          placeholder="Select Muncipality"
        >
          <option value="">- Select -</option>
          {refactoredmunsList?.length &&
            refactoredmunsList?.map((item) => (
              <option key={item.label} value={item.value}>
                {item.label}
              </option>
            ))}
        </Form.Select>
      </div>
      <div className="select">
        <Form.Label>Area</Form.Label>
        <Form.Select
          defaultValue=""
          disabled={!hasChosenGov || !selectedMun}
          onChange={handleChangeLocality}
          value={selectedLocality}
          placeholder="Select Area"
        >
          <option value="">- Select -</option>
          {refactoredLocalitiesList?.length &&
            refactoredLocalitiesList?.map((item) => (
              <option key={item.label} value={item.value}>
                {item.label}
              </option>
            ))}
        </Form.Select>
      </div>
      <button
        className="btn btn--primary"
        style={{
          "--bg": "#FFCC00",
          color: "#023A6C",
        }}
        type="submit"
        form="mapSelectors"
        disabled={!allowEdit || !hasChosenGov || !selectedMun}
      >
        Select
      </button>
      <button
        className="btn btn--primary"
        style={{
          "--bg": "#FFCC00",
          color: "#023A6C",
        }}
        type="button"
        onClick={handleReset}
      >
        Reset
      </button>
    </form>
  );
}

export default MapSelectors;
